// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Z0gm","delete":"styles_delete__9qMTK","update":"styles_update__3FQ5z","add":"styles_add__2OGOS"};